import { render, staticRenderFns } from "./MSPointHistoryList.vue?vue&type=template&id=ed7abc7a&"
import script from "./MSPointHistoryList.vue?vue&type=script&lang=js&"
export * from "./MSPointHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./MSPointHistoryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports